import { vars } from "@common/styles";
import { CopyAction } from "@main/pages/Release/views/MetricDetails/shared/EndpointUrl.styles";
import styled from "styled-components";

export const EndpointList = styled.div`
  display: grid;
  grid-template-columns: max-content max-content 1fr;
  row-gap: 0.6rem;
  align-items: center;
  margin-top: 1.2rem;
`;

export const EndpointRow = styled.div`
  display: contents;

  &:hover ${CopyAction} {
    opacity: 1;
    pointer-events: auto;
  }
`;

export const MethodBadge = styled.span`
  border: 2px solid ${vars.colors.grey90};
  border-radius: 2rem;
  padding: 0.3rem 1rem;
  font-size: 1.4rem;
  color: ${vars.colors.grey60};
  white-space: nowrap;
  font-family: Roobert, serif;
  text-align: center;
  letter-spacing: 0.02em;
  line-height: 1.8rem;
`;

export const WarningIconWrapper = styled.span`
  font-size: 1.4rem;
  flex-shrink: 0;
  line-height: 1;
`;

export const ErrorIconWrapper = styled.span`
  display: inline-flex;
  flex-shrink: 0;

  img {
    width: 2.4rem;
    height: 2.4rem;
  }
`;
